import { useAtomValue, useSetAtom } from "jotai";
import { useCallback } from "react";
import {
  clearPromotionsFilterAtom,
  getPromotionsAtom,
  isDefaultPromotionsFilter,
  promotionsAtom,
  promotionsCurrentPageAtom,
  promotionsErrorAtom,
  promotionsFilterInfoAtom,
  promotionsIsLoadingAtom,
  promotionsIsRefreshingAtom,
  promotionsListAtom,
  promotionsPageLimitAtom,
  promotionsTotalCountAtom,
  setPromotionsCurrentPageAtom,
  setPromotionsFilterAtom,
  setPromotionsIsFilterAppliedAtom,
} from "@/store/promotion";

interface GetPromotionsParams {
  isLoading: boolean;
  isRefreshing: boolean;
}

export function usePromotions() {
  const promotions = useAtomValue(promotionsListAtom);
  const isLoading = useAtomValue(promotionsIsLoadingAtom);
  const isRefreshing = useAtomValue(promotionsIsRefreshingAtom);
  const error = useAtomValue(promotionsErrorAtom);
  const totalCount = useAtomValue(promotionsTotalCountAtom);
  const currentPage = useAtomValue(promotionsCurrentPageAtom);
  const pageLimit = useAtomValue(promotionsPageLimitAtom);
  const filterInfo = useAtomValue(promotionsFilterInfoAtom);
  const isFilterApplied = useAtomValue(promotionsAtom).isFilterApplied;

  const setFilter = useSetAtom(setPromotionsFilterAtom);
  const clearFilter = useSetAtom(clearPromotionsFilterAtom);
  const setIsFilterApplied = useSetAtom(setPromotionsIsFilterAppliedAtom);
  const setCurrentPage = useSetAtom(setPromotionsCurrentPageAtom);
  const getPromotionsAction = useSetAtom(getPromotionsAtom);

  const getPromotions = useCallback(
    (params: GetPromotionsParams) => getPromotionsAction(params),
    [getPromotionsAction]
  );

  return {
    promotions,
    isLoading,
    isRefreshing,
    error,
    totalCount,
    currentPage,
    pageLimit,
    filterInfo,
    isFilterApplied,
    setFilter,
    clearFilter,
    setIsFilterApplied,
    setCurrentPage,
    getPromotions,
    isDefaultFilter: isDefaultPromotionsFilter,
  };
}

export type { PromotionsFilterInfo } from "@/store/promotion/promotionFilter.utils";
export type { GetPromotionsParams };
